import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { PropsWithChildren, ReactNode } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  /** Extra actions rendered before the acknowledge button, e.g. a link out of the flow. */
  actions?: ReactNode;
};

/**
 * Shell for the "you pressed Next too early" dialogs. Each flow resolves its own
 * title and message; the dialog owns the layout and the acknowledge button.
 */
export const BookingValidationDialog = ({
  open,
  onClose,
  title,
  message,
  actions,
  children
}: PropsWithChildren<Props>) => (
  <NoddiDialog
    dialogHeaderClassName='text-start text-balance'
    open={open}
    onClose={onClose}
    title={title}
    description={message}
    footer={
      <div className='flex justify-end gap-2'>
        {actions}
        <NoddiButton onClick={onClose} variant='primary'>
          <Trans>Got it</Trans>
        </NoddiButton>
      </div>
    }
  >
    {children}
  </NoddiDialog>
);
